import _ from 'lodash';
import React from 'react';

import {INVOICE_STATUSES, XERO_STATUSES} from 'ducks/reporting';

import './styles.css';

interface InvoiceStatusTagProps {
  status: string;
  overdue?: number;
}

const STATUS_TO_COLOR_MAPPER = {
  [INVOICE_STATUSES.PARTIALLY_PAID]: {
    displayLabel: 'Partialy paid',
    backgroundColor: '#FFE6C2',
    textColor: '#E96200',
    borderColor: '#FFE6C2'
  },
  [INVOICE_STATUSES.PAID]: {
    displayLabel: 'Paid',
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#D4F1CA'
  },
  [INVOICE_STATUSES.VOID]: {
    displayLabel: 'Void',
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#d2d9e2'
  },
  [INVOICE_STATUSES.UPCOMING]: {
    displayLabel: 'Upcoming',
    backgroundColor: '#49EEE9',
    textColor: '#006A67',
    borderColor: '#49EEE9'
  },
  [INVOICE_STATUSES.PAYMENT_PENDING]: {
    displayLabel: 'Payment pending',
    backgroundColor: '#E1E8F0',
    textColor: '#6E7B8C',
    borderColor: '#6E7B8C'
  },
  [INVOICE_STATUSES.PAYMENT_FAILED]: {
    displayLabel: 'Payment failed',
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444'
  },
  [INVOICE_STATUSES.OVERDUE]: {
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444'
  },
  [XERO_STATUSES.NOT_SYNCED]: {
    displayLabel: 'Not synced',
    backgroundColor: '#FF4444',
    textColor: '#FFFFFF',
    borderColor: '#FF4444'
  },
  [INVOICE_STATUSES.FULLY_CREDIT]: {
    displayLabel: 'Fully credit',
    backgroundColor: '#D4F1CA',
    textColor: '#228100',
    borderColor: '#D4F1CA'
  }
};

class InvoiceStatusTag extends React.Component<InvoiceStatusTagProps> {
  static NOT_SYNCED = XERO_STATUSES.NOT_SYNCED;
  static VOID = INVOICE_STATUSES.VOID;

  render() {
    const {status, overdue} = this.props;

    let {backgroundColor, textColor, borderColor, displayLabel}: any = _.get(
      STATUS_TO_COLOR_MAPPER,
      status,
      {}
    );

    if (
      status === INVOICE_STATUSES.OVERDUE &&
      !_.isNil(overdue) &&
      overdue === 0
    ) {
      displayLabel = 'Overdue today';
    }

    if (
      status === INVOICE_STATUSES.OVERDUE &&
      !_.isNil(overdue) &&
      overdue > 0
    ) {
      displayLabel = `${overdue} days overdue`;
    }

    return (
      <div
        className="InvoiceStatusTag colab-centered colab-bold"
        style={{
          backgroundColor,
          borderColor,
          color: textColor
        }}>
        {displayLabel}
      </div>
    );
  }
}

export default InvoiceStatusTag;
